module.exports = "/_next/static/images/b953f516cc7256f4a2c4780895a28485-nobureaucracy@1x.png.webp";